import React, { Component } from "react";

import "./inputs.css";
import "react-datepicker/dist/react-datepicker.css";

import Input from "../../components/inputs/input";

import DatePicker from "react-datepicker";

const DATE_MASK = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];

class ConsultaInputDate extends Component {
  render() {
    function handleFocus(e) {
      e.target.select();
    }

    return (
      <div className="row">
        <div className="col-xs-12 col-md-6">
          <DatePicker
            className="consulta-filters-date start-date"
            locale="pt"
            name="data_inicio"
            id="data_inicio"
            placeholder="dd/mm/aaaa"
            dateFormat="dd/MM/yyyy"
            value={this.props.dia_inicio}
            selected={this.props.dia_inicio}
            onChange={this.props.onChange_inicio}
            onFocus={handleFocus}
            autoComplete="off"
            customInput={<Input type="text" label="Data de início" mask={DATE_MASK} width="100%" />}
          />
        </div>
        <div className="col-xs-12 col-md-6">
          <DatePicker
            className="consulta-filters-date end-date"
            locale="pt"
            name="data_fim"
            id="data_fim"
            placeholder="dd/mm/aaaa"
            dateFormat="dd/MM/yyyy"
            value={this.props.dia_fim}
            selected={this.props.dia_fim}
            onChange={this.props.onChange_fim}
            onFocus={handleFocus}
            autoComplete="off"
            customInput={<Input type="text" label="Data final" mask={DATE_MASK} width="100%" />}
          />
        </div>
      </div>
    );
  }
}

export default ConsultaInputDate;
